export function withTimeout<T>(timeoutInMs: number, promise: Promise<T>): Promise<T> {
    const timeoutPromise = new Promise<never>((_resolve, reject) => {
        setTimeout(() => reject(new Error('Timeout')), timeoutInMs);
    });

    return Promise.race([
        timeoutPromise,
        promise
    ]);
}